import { render, staticRenderFns } from "./OfficerDetailsPage.vue?vue&type=template&id=391f1193&scoped=true"
import script from "./OfficerDetailsPage.vue?vue&type=script&lang=js"
export * from "./OfficerDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./OfficerDetailsPage.vue?vue&type=style&index=0&id=391f1193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f1193",
  null
  
)

export default component.exports